import { createStyles } from '@mantine/core';

const useSectionStyles = createStyles((theme) => ({
  pageWrapper: {
    [theme.fn.largerThan('md')]: {
      paddingTop: theme.spacing.md,
      paddingBottom: theme.spacing.md,
    },
  },
  container: {
    position: 'relative',
  },
  prev: {
    gridArea: 'prev',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing.md,
    right: theme.spacing.xs,

    [theme.fn.smallerThan('md')]: {
      top: 8,
    },

    '&.webView': {
      order: 1,
      top: 0,
    },
  },
  backButton: {
    position: 'absolute',
    top: 1,
    padding: 0,

    '&.webView': {
      order: 3,
    },
  },
  header: {
    position: 'sticky',
    top: 0,
    padding: `${theme.spacing.xs}px ${theme.spacing.xs}px ${theme.spacing.xs / 2}px`,
    marginLeft: -theme.spacing.xs,
    marginRight: -theme.spacing.xs,
    backdropFilter: 'blur(5px)',
    zIndex: 1,
    marginTop: -theme.spacing.md,
  },
  actions: {
    position: 'sticky',
    bottom: 0,
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
    marginTop: theme.spacing.xs,
    width: 248,
    borderRadius: theme.radius.md,
    margin: '0 auto',
  },
  submit: {
    gridArea: 'next',
    width: '100%',
  },
  next: {
    gridArea: 'next',
  },
  button: {
    width: '100%',

    '&:hover': {
      // This has to be important because of the specificity of the button styles
      opacity: '1 !important',
      background: theme.colors.blue[2],
      transition: 'background 0.2s',
    },
  },
  title: {
    fontSize: '20px',
    lineHeight: '30px',
    fontFamily: theme.other.fontFamily.hubotSansExpanded,
    fontStretch: '75%',
    fontWeight: 900,
    color: theme.colors.gray2[7],
    textTransform: 'uppercase',
    textAlign: 'center',
    width: 390,
    margin: '0 auto',

    [theme.fn.smallerThan('md')]: {
      fontSize: '18px',
      lineHeight: '28px',
      width: '100%',
    },

    [theme.fn.smallerThan('sm')]: {
      fontSize: '16px',
      lineHeight: '26px',
    },

    '&.webView': {
      order: 2,
    },
  },
  indicator: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: theme.colors.blue[4],
  },
}));

export { useSectionStyles };
